import { MessageBarType } from "@fluentui/react";
import Alert, { AlertColor } from '@mui/material/Alert';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import LoaderComp from '../../components/Loader/LoaderComp';
import Message from "../../components/Message/Message";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { Organization, OrganizationNameVO, OrganizationUserServiceVO } from "../../model/OrganizationModel";
import {
  GetD4SignSafeBox,
  GetOneOrganizationWithContractResource,
  GetOrganization,
  GetOrganizationAdminUsers,
  SetAllowDrive,
  SetD4Sign,
  SetName,
  SetUserService,
  UnsetD4Sign,
  UnsetUserService
} from "../../services/OrganizationServices";
import { TemplateDefaultAdminConsole } from "../AdminConsole/components/TemplateDefaultAdminConsole";
import { 
  Box, 
  Button, 
  FormControlLabel, 
  MenuItem, 
  Radio, 
  RadioGroup,
  TextField,
  Checkbox,
  Paper,
  Typography,
  Snackbar
} from "@mui/material";
import { KeydriveBallon } from "../../components/KeydriveComponents/Ballons/KeydriveBallon";
import { RuleCard } from "../AdminConsole/Workspaces/components/NewWorkspace/components/RuleCard";
import { Tune, SaveOutlined, Close } from "@mui/icons-material";
import { KeyDriveDialog } from "../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import InfoIcon from '@mui/icons-material/Info';
import { KeyDriveBodyMax } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import KeydriveSnackbar from "../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";

export interface IOptionsSelect {
  key: string;
  text: string;
}

const OrganizationConfig = (props: any) => { 
  const [orgFound, setOrgFound] = useState<Organization | null>(null);
  const [popupOk, setPopupOk] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [nameChanged, setNameChanged] = useState<string>("");
  const [adminOrg, setAdminOrg] = useState<boolean>(false);
  const profile = useProfile();
  const { t } = useTranslation();
  const { nameOrg } = useParams();
  const [reaload, setReaload] = useState<boolean>(false);
  const [options, setOptions] = useState<IOptionsSelect[]>([]);
  const [keySelect, setKeySelect] = useState<string | null>(null);
  const [safeBox, setSafeBox] = useState<string | null>(null);
  const [allow, setAllow] = useState<boolean>(false);
  const [blockD4Sign, setBlockD4Sign] = useState<string | undefined>(undefined);
  const [optionsAdminUsers, setOptionsAdminUsers] = useState<IOptionsSelect[]>([]);
  const [keySelectAdminUsers, setKeySelectAdminUsers] = useState<string | null>(null);
  const [realoadAdminUsers, setRealoadAdminUsers] = useState<boolean>(false);
  const [blockAdminUsers, setBlockAdminUsers] = useState<string | undefined>(undefined);
  const [loadOrganization, setLoadOrganization] = useState<boolean>(true);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  
  const [originalName, setOriginalName] = useState<string>("");
  const [originalServiceUser, setOriginalServiceUser] = useState<string>("");
  const [originalD4SignSafe, setOriginalD4SignSafe] = useState<string | null>(null);

  const [d4SignLoaded, setD4SignLoaded] = useState<boolean>(false);
  const [adminUsersLoaded, setAdminUsersLoaded] = useState<boolean>(false);
  const [organizationLoaded, setOrganizationLoaded] = useState<boolean>(false);
  const [messageSnack, setMessageSnack] = useState<string | undefined>(undefined);
  const [colorSnack, setColorSnack] = useState<AlertColor>("error");

  useEffect(() => {
    if(profile.organizations != undefined)
    {
      for(let organization of profile.organizations)
      {
        if(nameOrg == organization.internalName)
        {
          if(organization.isAdmin == true)
          {
            setAdminOrg(true);
          }
          break;
        }
      }
    }
  }, [profile]);

  useEffect(() => {
    if (d4SignLoaded && organizationLoaded && options.length > 0) {
      if (safeBox != null) {
        setKeySelect(safeBox);
        setOriginalD4SignSafe(safeBox);
      } else {
        setKeySelect(null);
        setOriginalD4SignSafe(null);
      }
    }
  }, [d4SignLoaded, organizationLoaded, options, safeBox]);

  useEffect(() => {
    if (adminUsersLoaded && organizationLoaded && orgFound) {
      const serviceUserId = orgFound.serviceUserId || "";
      setKeySelectAdminUsers(serviceUserId);
      setOriginalServiceUser(serviceUserId);
    }
  }, [adminUsersLoaded, organizationLoaded, orgFound]);

  function d4Sign()
  {
    setReaload(true);
    setBlockD4Sign(undefined);
    setD4SignLoaded(false);
    GetD4SignSafeBox()
    .then((result) =>{
      let optionInter:IOptionsSelect[] = [];
      result.map((d4SignSafeBox) =>
      {
        optionInter.push({
          key:d4SignSafeBox.uuidSafe,
          text:d4SignSafeBox.nameSafe
        });
      });
      setOptions(optionInter);
      setD4SignLoaded(true);
    })
    .catch((error)=>{
      if( error.response && error.response.data && typeof error.response.data  === 'string')
      {
        setBlockD4Sign(error.response.data);
        setMessageSnack(error.response.data);
        setColorSnack("error");
      }
      else
      {
        setBlockD4Sign(t("OrganizationConfig.ErrorGettingSafe"));
        setMessageSnack(t("OrganizationConfig.ErrorGettingSafe"));
        setColorSnack("error");
      }

      setKeySelect(null);
      setOptions([]);
      setD4SignLoaded(true);
    })
    .finally(() => {
      setReaload(false);
    });
  }

  function getAdminUsers()
  {
    setRealoadAdminUsers(true);
    setAdminUsersLoaded(false);
    if(nameOrg){
      GetOrganizationAdminUsers(nameOrg)
      .then((result) =>{
        let optionInter: IOptionsSelect[] = [];
        result.map((adminUsers) =>
        {
          optionInter.push({
            key:adminUsers.id,
            text:adminUsers.name
          });
        });

        setOptionsAdminUsers(optionInter);
        setAdminUsersLoaded(true);
      })
      .catch((error)=>{
        if( error.response && error.response.data && typeof error.response.data  === 'string')
        {
          setBlockAdminUsers(error.response.data);
          setMessageSnack(error.response.data);
          setColorSnack("error");
        }
        else
        {
          setBlockAdminUsers(t("ErrorReceivingAdminUsers.message"));
          setMessageSnack(t("ErrorReceivingAdminUsers.message"));
          setColorSnack("error");
        }
        setOptionsAdminUsers([]);
        setAdminUsersLoaded(true);
      })
      .finally(() => {
        setRealoadAdminUsers(false);
      });
    }
  }

  useEffect(() => {
    d4Sign();
    getAdminUsers();

    if (nameOrg != undefined) {
      setLoadOrganization(true);
      setOrganizationLoaded(false);
      GetOneOrganizationWithContractResource(nameOrg)
        .then((message) => {
          if (message != null) {
            setOrgFound(message);
            
            if (message.name) {
              setNameChanged(message.name);
              setOriginalName(message.name);
            }
            
            if (message.d4SignSafeBox) {
              setSafeBox(message.d4SignSafeBox);
            } else {
              setSafeBox(null);
            }
            
            if(message.allowDrive){
              setAllow(true);
            } else {
              setAllow(false);
            }
            
            setOrganizationLoaded(true);
          } 
        })
        .catch((error) => {
          if( error.response && error.response.data && typeof error.response.data  === 'string')
          {
            setMessage(error.response.data);

            setMessageSnack(error.response.data);
            setColorSnack("error");
          }
          else
          {
            setMessage(t("OrganizationConfig.OrganizationNotFound"));
            setMessageSnack(t("OrganizationConfig.OrganizationNotFound"));
            setColorSnack("error");
          }

          setPopupOk(true);
          setOrganizationLoaded(true);
        })
        .finally(() =>{
          setLoadOrganization(false);
        });
    } else {
      setMessage(t("OrganizationConfig.OrganizationNotFound"));
      setMessageSnack(t("OrganizationConfig.OrganizationNotFound"));
      setColorSnack("error");

      setPopupOk(true);
      setLoadOrganization(false);
      setOrganizationLoaded(true);
    }
  }, [nameOrg]);


  function EditUserService() {
    if (orgFound != null && orgFound.id) {
      let itemModelo: OrganizationUserServiceVO = {
        organizationId: orgFound.id,
        serviceUserId: keySelectAdminUsers!
      };
      
      SetUserService(itemModelo)
      .then(() => {
        setOriginalServiceUser(keySelectAdminUsers!);
        setMessageSnack(t("OrganizationConfig.SuccessfullyEdited"));
        setColorSnack("success");

        setOrgFound({...orgFound, serviceUserId: keySelectAdminUsers!});
      })
      .catch((error)=> {
        if( error.response && error.response.data && typeof error.response.data  === 'string'){
          setMessageSnack(error.response.data);
          setColorSnack("error");
        }
        else
        {
          setMessageSnack(t("OrganizationConfig.SomethingWentWrong"));
          setColorSnack("error");
        }
      });
    }
  }


  function editOrganization() {
    if (orgFound != null && orgFound.id) {
      let itemModelo: OrganizationNameVO = {
        organizationId: orgFound.id,
        organizationName: nameChanged,
      };
      
      SetName(itemModelo)
      .then(() => {
        setOriginalName(nameChanged);
        
        setOrgFound({...orgFound, name: nameChanged});
      })
      .catch((error)=> {
        if( error.response && error.response.data && typeof error.response.data  === 'string'){
          setMessageSnack(error.response.data);
          setColorSnack("error");
        }
        else
        {
          setMessageSnack(t("OrganizationConfig.SomethingWentWrong"));
          setColorSnack("error");
        }
      });
    }
  }

  function cancelNameEdit() {
    setNameChanged(originalName);
  }

  function unSaveD4Sign() {
    if (orgFound != undefined && orgFound.id != undefined) {
      unsetInternal(orgFound.id)
    }
  }


  function unsaveUserService() {
    if (orgFound != undefined && orgFound.id != undefined) {
      unsetServiceUser(orgFound.id);
    }
  }

  function saveD4Sign() {
    if (orgFound != undefined && orgFound.id != undefined) {
      if (keySelect != null) {
        SetD4Sign({
          organizationId:orgFound.id,
          d4SignSafeBox:keySelect
        })
        .then(()=>{
          setOriginalD4SignSafe(keySelect);
          setSafeBox(keySelect);
          
          setOrgFound({...orgFound, d4SignSafeBox: keySelect});
        })
        .catch((error)=> {
          if( error.response && error.response.data && typeof error.response.data  === 'string'){
            setMessageSnack(error.response.data);
            setColorSnack("error");
          }
          else
          {
            setMessageSnack(t("OrganizationConfig.SomethingWentWrong"));
            setColorSnack("error");
          }
        });
      }
      else
      {
        unsetInternal(orgFound.id)
      }
    }
  }

  function unsetInternal(thisIdOrg:string)
  {
    UnsetD4Sign(thisIdOrg)
    .then(()=>{
      setOriginalD4SignSafe(null);
      setSafeBox(null);
      setKeySelect(null);

      setMessageSnack("Cofre desatribuído com sucesso");
      setColorSnack("success");
      
      if (orgFound) {
        setOrgFound({...orgFound, d4SignSafeBox: undefined});
      }
    })
    .catch((error)=> {
      if( error.response && error.response.data && typeof error.response.data  === 'string'){
        setMessageSnack(error.response.data);
        setColorSnack("error");      
      }
      else
      {
        setMessageSnack(t("OrganizationConfig.SomethingWentWrong"));
        setColorSnack("error");
      }
    });
  }
  
  function unsetServiceUser(thisIdOrg:string) {
    UnsetUserService(thisIdOrg)
    .then(()=>{
      setMessageSnack("Usuário de serviço desatribuído com sucesso");
      setColorSnack("success");
      if (orgFound) {
        setOrgFound({...orgFound, serviceUserId: undefined});
      }
    })
    .catch((error)=> {
      if( error.response && error.response.data && typeof error.response.data  === 'string')
      {
        setMessageSnack(error.response.data);
        setColorSnack("error");
      }
      else
      {
        setMessageSnack(t("OrganizationConfig.SomethingWentWrong"));
        setColorSnack("error");
      }
    });
  }

  function changeAllowDrive (event: React.ChangeEvent<HTMLInputElement>) {
    const checked = event.target.checked;
    setAllow(checked);
    
    if (orgFound != null && orgFound.id) {
      let itemModelo: Organization = {
        id: orgFound.id,
        allowDrive: checked
      };
      
      SetAllowDrive(itemModelo)
      .then(() => {
        setMessageSnack("Configuração de permitir Drive atualizada com sucesso");
        setColorSnack("success");
        setOrgFound({...orgFound, allowDrive: checked});
      })
      .catch((error)=> {
        setAllow(!checked);
        
        if( error.response && error.response.data && typeof error.response.data  === 'string'){
          setMessageSnack(error.response.data);
          setColorSnack("error");
        }
        else
        {
          setMessageSnack(t("OrganizationConfig.SomethingWentWrong"));
          setColorSnack("error");
        }
      });
    }
  };

  if (loadOrganization || !organizationLoaded || !d4SignLoaded || !adminUsersLoaded) {
    return <LoaderComp />
  }

  return (
    <TemplateDefaultAdminConsole iconTitle={<Tune />} title={t("AdminConsole.Preferences.Title")} subtitle="">
      <Box>
        <Typography 
          variant="h6" 
          sx={{ 
            fontSize: '16px', 
            fontWeight: 600, 
            color: '#000',
            mb: 2
          }}
        >
          {t("OrganizationConfig.OrganizationInformation")}
        </Typography>

        <KeydriveBallon />

        <Box sx={{ mb: 2, mt: 4 }}>
          <Typography variant="body2" sx={{ mb: 0.5, fontSize: '13px', color: '#424242' }}>
            {t("OrganizationConfig.Name")}*
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextField
              fullWidth
              value={nameChanged}
              onChange={(e) => setNameChanged(e.target.value)}
              placeholder="Lorem ipsum"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: '14px',
                  '& fieldset': {
                    borderColor: '#D0D0D0',
                  }
                }
              }}
              variant="standard"
            />
            <Button
              variant="contained"
              onClick={editOrganization}
              disabled={nameChanged === originalName || nameChanged.trim() === ""}
              sx={{
                textTransform: 'none',
                bgcolor: '#22638D',
                fontSize: '13px',
                fontWeight: 400,
                px: 2.5,
                minWidth: 'auto',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#1976D2',
                  boxShadow: 'none'
                },
                '&:disabled': {
                  bgcolor: '#E0E0E0',
                  color: '#9E9E9E'
                }
              }}
              startIcon={<SaveOutlined />}
            >
              {t("OrganizationConfig.Save")}
            </Button>
            <Button
              variant="outlined"
              onClick={cancelNameEdit}
              disabled={nameChanged === originalName}
              sx={{
                textTransform: 'none',
                borderColor: '#22638D',
                color: '#22638D',
                fontSize: '13px',
                fontWeight: 400,
                px: 2.5,
                minWidth: 'auto',
                '&:hover': {
                  borderColor: '#9E9E9E',
                  bgcolor: 'transparent'
                },
                '&:disabled': {
                  borderColor: '#E0E0E0',
                  color: '#9E9E9E'
                }
              }}
              startIcon={<Close />}
            >
              {t("OrganizationConfig.Cancel")}
            </Button>
          </Box>
        </Box>

        {/* Usuário de serviço */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="body2" sx={{ mb: 0.5, fontSize: '13px', color: '#424242' }}>
            {t("OrganizationConfig.ServiceUser")}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <TextField
              fullWidth
              select
              value={keySelectAdminUsers || ""}
              onChange={(e) => setKeySelectAdminUsers(e.target.value)}
              size="small"
              SelectProps={{
                displayEmpty: true,
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: '14px',
                  '& fieldset': {
                    borderColor: '#D0D0D0',
                  }
                }
              }}
              variant="standard"
            >
              {optionsAdminUsers.map((user) => (
                <MenuItem key={user.key} value={user.key}>
                  {user.text}
                </MenuItem>
              ))}
            </TextField>
            <Button
              variant="contained"
              onClick={EditUserService}
              disabled={keySelectAdminUsers === originalServiceUser}
              sx={{
                textTransform: 'none',
                bgcolor: '#22638D',
                fontSize: '13px',
                fontWeight: 400,
                px: 2.5,
                minWidth: 'auto',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#1976D2',
                  boxShadow: 'none'
                },
                '&:disabled': {
                  bgcolor: '#E0E0E0',
                  color: '#9E9E9E'
                }
              }}
              startIcon={<SaveOutlined />}
            >
              {t("OrganizationConfig.Save")}
            </Button>
            <Button
              variant="outlined"
              onClick={unsaveUserService}
              disabled={keySelectAdminUsers === originalServiceUser}
              sx={{
                textTransform: 'none',
                borderColor: '#22638D',
                color: '#22638D',
                fontSize: '13px',
                fontWeight: 400,
                px: 2.5,
                minWidth: 'auto',
                '&:hover': {
                  borderColor: '#9E9E9E',
                  bgcolor: 'transparent'
                },
                '&:disabled': {
                  borderColor: '#E0E0E0',
                  color: '#9E9E9E'
                }
              }}
              startIcon={<Close />}
            >
              {t("OrganizationConfig.Cancel")}
            </Button>
          </Box>
        </Box>

        <Box mb="16px">
          <KeyDriveBodyMax
            color="#2D2D2D"
            needBold
            needEllipses={false}
            text={t("AdminConsole.Preferences.Storage")}
            sxStyles={{ mt: "8px" }}
          />
        </Box>
        <RuleCard 
            text={t("AdminConsole.Preferences.AllowDrive")}
            checked={allow}
            onChange={changeAllowDrive}
            width="100%"
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 4 }}>
          <Typography 
            variant="h6" 
            sx={{ 
              fontSize: '16px', 
              fontWeight: 600, 
              color: '#000'
            }}
          >
            {t("OrganizationConfig.ElectronicSignature")}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 2, justifyContent: "end" }}>
            <Button
              variant="contained"
              onClick={saveD4Sign}
              disabled={reaload || blockD4Sign != undefined || keySelect === originalD4SignSafe}
              sx={{
                textTransform: 'none',
                bgcolor: '#22638D',
                fontSize: '13px',
                fontWeight: 400,
                px: 2.5,
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#1976D2',
                  boxShadow: 'none'
                },
                '&:disabled': {
                  bgcolor: '#E0E0E0',
                  color: '#9E9E9E'
                }
              }}
              startIcon={<SaveOutlined />}
            >
              {t("OrganizationConfig.Save")}
            </Button>
            <Button
              variant="outlined"
              onClick={unSaveD4Sign}
              disabled={originalD4SignSafe == undefined || originalD4SignSafe == null}
              sx={{
                textTransform: 'none',
                borderColor: '#22638D',
                color: '#22638D',
                fontSize: '13px',
                fontWeight: 400,
                px: 2.5,
                '&:hover': {
                  borderColor: '#9E9E9E',
                  bgcolor: 'transparent'
                },
                '&:disabled': {
                  borderColor: '#E0E0E0',
                  color: '#9E9E9E'
                }
              }}
              startIcon={<Close />}
            >
              Deletar atribuição de cofre
            </Button>
          </Box>
        </Box>


        {options?.length <= 0 || reaload ? (
          <LoaderComp />
        ) : (
          <Box sx={{ 
            border: '1px solid #E0E0E0', 
            borderRadius: '6px',
            p: 2,
            bgcolor: '#FFF'
          }}>
            <RadioGroup
              value={keySelect || ""}
              onChange={(e) => setKeySelect(e.target.value)}
            >
              {options.map((d4sign) => (
                <FormControlLabel
                  key={d4sign.key}
                  value={d4sign.key}
                  control={
                    <Radio 
                      size="small"
                      sx={{
                        color: '#9E9E9E',
                        '&.Mui-checked': {
                          color: '#2196F3',
                        },
                      }}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#424242' }}>
                      {d4sign.text}
                    </Typography>
                  }
                  sx={{ mb: 0.5 }}
                />
              ))}
            </RadioGroup>
          </Box>
        )}
      </Box>
      <KeydriveSnackbar 
          message={messageSnack}
          open={messageSnack !== undefined}
          variant={colorSnack}
          onClose={() => setMessageSnack(undefined)}
      />
    </TemplateDefaultAdminConsole>
  );
};

export default OrganizationConfig;